import {Component, 
	OnInit, 
	ElementRef, 
	ViewChild, 
	ChangeDetectionStrategy, 
	ChangeDetectorRef, 
	HostListener, 
	ViewChildren, 
    Inject} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from 'rxjs';
//Datasource
//Service
import { SubheaderService } from '../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../core/_base/crud';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { LichSuThaoTacKhoModel } from './lich-su-thao-tac-kho.model';
import { DungChungService } from '../../nfc/dung-chung/__services/dung-chung.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'm-lich-su-thao-tac-kho-dialog',
	templateUrl: './lich-su-thao-tac-kho-dialog.component.html',
	//styleUrls: ['../phieu-nhap-kho-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class LichSuThaoTacKhoDialogComponent implements OnInit{

    /*Config Form */
    CONFIG: CommonConFig;
      // Table fields
    displayedColumns = [];
    
	availableColumns = [
		// {
		// 	stt: 0,
        //     name: 'select',
        //     displayName: 'Check chọn',
		// 	alwaysChecked: true,
		// 	isShow: true
        // },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'CreatedTime',
            displayName: 'Thời gian',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'CreatedName',
            displayName: 'Người thao tác',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'action',
            displayName: 'Thao tác',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'content',
            displayName: 'Nội dung thao tác',
            alwaysChecked: false,
			isShow: true
        },
       
    ];

    @ViewChildren('focus') focus ;
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;
	@ViewChild('searchFullText', {static: true}) searchFullText: ElementRef;

    // Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<LichSuThaoTacKhoModel>(true, []);

	deNghiNhapKhoResult: LichSuThaoTacKhoModel[] = [];
	tmpLichSuThaoTackhoResult: LichSuThaoTacKhoModel[] = [];

	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	viewLoading = false;
	
	previousIndex: number;
    fixedPoint = 2;
    
    /* Danh sách chi tiết phiếu nhập kho để trừ or cộng lại số lượng khi add hàng hóa */
    
    constructor(
		public dialogRef: MatDialogRef<LichSuThaoTacKhoDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		private route: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		protected _sanitizer: DomSanitizer,
		private dungChungService: DungChungService,
		private layoutUtilsService: LayoutUtilsService) {
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.dialogRef.disableClose = true;
		}

    /*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {
		
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		this.showColumnsInTable();
		this.applySelectedColumns();
		if (this.data.Id > 0) {
			this.dungChungService.lichsuthaotackho({
				Id: this.data.Id,
				menu: this.data.menu
			}).subscribe(res => {
				this.viewLoading = false;
				if (res && res.status == 1) {
					this.tmpLichSuThaoTackhoResult = res.data;
					this.tmpLichSuThaoTackhoResult.forEach(element => {
						let split = element.content.split(';');
						if(split.length > 1){
							element.content = '';
							split.sort((a, b) => {
								console.log(a.charAt(6))
								let aNumber = parseInt(a.charAt(5));
								let bNumber = parseInt(b.charAt(5));
								return aNumber - bNumber;
							});
							split.forEach((item, index) => {
								if (index < split.length - 1) {
									element.content += (item + '<br>');
								} else {
									element.content += item;
								}
							});
						}
					});
					this.changeDetect.detectChanges();
					this.tmpLichSuThaoTackhoResult = [...this.tmpLichSuThaoTackhoResult]
				} else
					this.layoutUtilsService.showErorr(res.error.message);
				
			})
		}
		// // If the PhieuThongTinHangVeTmp changes the sort order, reset back to the first page.
		//this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		/* Data load will be triggered in two cases:
		- when a pagination event occurs => this.paginator.page
		- when a sort event occurs => this.sort.sortChange
		**/
		// merge(this.sort.sortChange, this.paginator.page)
		// 	.pipe(
		// 		tap(() => {
		// 			this.loadDeNghiNhapKhoList();
		// 		})
		// 	)
		// 	.subscribe();

		// this.dialogRef.keydownEvents().subscribe(event => {
		// 	if (event.key == "Escape") {
		// 		this.back(true);
		// 	}
		// 	this.changeDetect.detectChanges();
		// });

		// Init DataSource
		
		//this.loadDeNghiNhapKhoList();
		//this.layoutUtilsService.setUpPaginationLabels(this.paginator);
	}
	safeHtml(html) {
		return this._sanitizer.bypassSecurityTrustHtml(html);
	}
	loadDeNghiNhapKhoList() {
		this.selection.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize
		);
	}

	loadDeNghiNhapKhoListInit() {
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize
		);
	}

	filterConfiguration(): any {
		const filter: any = {};
		filter.deleted = this.data.deleted
		filter.add = this.data.add
		filter.type = 1; // Phiếu đề nghị
		filter.FullSearch = this.searchFullText.nativeElement.value;
		return filter;
	}
    /* -----------------------------------------------------------------------*/
    
    /*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
    ValidateChangeNumberEvent(columnName:string, item:any, event: any) {
		var count = 0;
		for(let i = 0; i < event.target.value.length; i++){
			if(event.target.value[i] == '.'){
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
    formatNumber(item: string){
        if(item == '' || item == null || item == undefined)	return '';
        return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
    }
    f_currency(value: string): any {
        if (value == null || value == undefined || value == '') value = '0.00';
        let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
        return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
    }
    f_currency_V2(value: string): any {
        if (value == null || value == undefined || value == '') return '';
        let nbr = Number((value + '').replace(/,/g, ""));
        return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    /* -----------------------------------------------------------------------*/
    
    /*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
	getFormatDate(v: string = '') {
		if (v != '' && v != undefined) {
			return v.includes('T') ? v.replace(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).*$/, "$3/$2/$1 $4:$5") : v.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1 00:00");
		}
		return '';
	}
    f_convertDate(p_Val: any) {
        if(p_Val == null || p_Val == undefined || p_Val == '') return '';
        let a = p_Val === "" ? new Date() : new Date(p_Val);
        return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}
    /* -----------------------------------------------------------------------*/

    /* ---------- HÀM HỖ TRỢ HIỂN THỊ CỘT TRÊN MENU VÀ CHECKBOX CHO ROW--------*/
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}
	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	isAllSelected() {
		// 
		const numSelected = this.selection.selected.length;
		const numRows = this.deNghiNhapKhoResult.length;
		return numSelected === numRows;
	}
	masterToggle() {
		// 
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpLichSuThaoTackhoResult.forEach(row => {
				this.selection.select(row)
			});
		}
	}
    /*----------------------------------------------------------------------- */
    
    /*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
	showColumnsInTable(){
        for(let i = 0; i < this.availableColumns.length; i++){
            if(this.availableColumns[i].isShow == false){
                this.selectedColumns.toggle(this.availableColumns[i]);
            }
        }
    }
    findIndexColumn(column: string){
        for( let i = 0; i < this.availableColumns.length; i++){
            if(this.availableColumns[i].name == column)
                return i;
        }
    }
    dragStarted(event: CdkDragStart, column: string) {
        this.previousIndex = this.findIndexColumn(column);
    }
    dropListDropped(event: CdkDropList, column: string) {
        if (event) {
            moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
            this.applySelectedColumns();
        }
    }
    applySelectedColumns() {
        let _selectedColumns = this.selectedColumns.selected;
        this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
        for(let i = 0; i < this.availableColumns.length; i++){
            this.selectedColumns.toggle(this.availableColumns[i]);
            for( let j = 0; j < _selectedColumns.length; j++){
                if( this.availableColumns[i].name == _selectedColumns[j].name){
                    this.selectedColumns.toggle(this.availableColumns[i]);
                    break;
                }
            }
        }
        const _applySelectedColumns: string[] = [];
        this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
        this.displayedColumns = _applySelectedColumns;
    }
	/*----------------------------------------------------------------------- */
	
	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back(close: boolean){
		setTimeout(() => 
		this.dialogRef.close(
			{ 
				dataAdd : close ? null : this.selection.selected,
			})
		, 300);
	}
	/*------------------------------------------------------------- */
}